/** Shared wire contract. Times describe preparation of the map, not collection of SERPs. */
export interface SerpMapSnapshotStatus {
  state: 'ready' | 'queued' | 'building' | 'failed';
  outdated: boolean;
  snapshot: { revision: string; builtAt: string } | null;
  completedGroups: number;
  totalGroups: number;
  error: string | null;
  checkedAt: string;
  nextCheckAt: string;
}

export interface SerpMapPending {
  pending: true;
  snapshotStatus: SerpMapSnapshotStatus;
}

export const SERP_MAP_REFRESH = {
  tickMs: 1_000,
  checkMs: 30_000,
  coalesceMs: 30_000,
  targetLagMs: 5 * 60_000,
  retryMs: 30_000,
  maxRetryMs: 120_000,
  activeMs: 24 * 3600_000,
} as const;
